<template>
	<div class="content background1">
		<div class="tableBox11">
			<div class="tableMes">
				<div class="table" style="padding: 0">
					<div class="treeMes">
						<p class="title">{{$t('label_1014')}}</p>
						<div class="chooseBox spaceBetween">
							<div class="selectBox">
								<div>
									<div class="selectChoose">
										<div class="selectText">
											<p>{{$t('label_567')}}</p>
										</div>
										<div class="select" style="width:320px;">
											<el-input v-model="name" clearable></el-input>
										</div>
									</div>
								</div>
								<div>
									<div class="selectChoose" style="margin-left: 50px;">
										<div class="selectText">
											<p>{{$t('label_70')}}</p>
										</div>
										<div class="select" style="width:350px;">
											<el-date-picker v-model="Readytime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange"
											 :range-separator="$t('label_264')" :start-placeholder="$t('label_329')" :end-placeholder="$t('label_388')">
											</el-date-picker>
										</div>
									</div>
								</div>
							</div>
							<div class="buttonBox">
								<div>
									<div class="chooseButton sendButton" @click="search({pageNum: 1,pageSize:pageSize,})"><i class="el-icon-search"></i>{{$t('btn_2')}}</div>
								</div>
							</div>
						</div>
						<!-- button -->
						<div class="spotMes2Box" style="height: calc(100% - 120px);">
<!--							<div class="buttonBox">-->
<!--								<div>-->
<!--									<div class="chooseButton searchButton" @click="exportClick" v-if="MenuRoleList.indexOf('61')>=0"><i class="el-icon-download"></i>导出</div>-->
<!--								</div>-->
<!--							</div>-->

							<div class="tableMin" style="height: calc(100% - 90px);">

								<el-table :empty-text="$t('label_357')" ref="singleTable" :data="tableDataList" highlight-current-row @current-change="handleCurrentChangeTreeTime"
								 border style="width: 100%;margin: 10px 0" height="100%" :header-cell-style="{'background-color': '#45494f','color': '#ffffff','padding':'2px 0px'}"
								 :cell-style="{'border-left':'1px solid #d7d7d7','border-bottom':'1px solid #d7d7d7'}">

									<el-table-column header-align="center" align="center" label="No" type="index" :index="getIndex" width="50">
									</el-table-column>
									<el-table-column prop="repairman" :label="$t('label_109')" align="left">
										<template slot-scope="scope">
											{{scope.row.repairman}} {{scope.row.repairmanDept==null?'':'('+scope.row.repairmanDept+')'}}
										</template>
									</el-table-column>
									<el-table-column prop="num" :label="$t('label_1055')" align="left">
										<el-table-column :label="$t('label_1056')" align="center">
											<template slot-scope="scope">
												{{scope.row.numAll}}/<span :class="scope.row.num>0?'redFont':''">{{scope.row.num}}</span>
											</template>
										</el-table-column>
										<el-table-column prop="orderTimeout" :label="$t('label_1057')" align="center">
											<template slot-scope="scope">
												<p :class="scope.row.orderTimeout>0?'louNum':''">{{scope.row.orderTimeout}}</p>
											</template>
										</el-table-column>
										<el-table-column prop="maintenanceTimeout" :label="$t('label_760')" align="center">
											<template slot-scope="scope">
												<p :class="scope.row.maintenanceTimeout>0?'louNum':''">{{scope.row.maintenanceTimeout}}</p>
											</template>
										</el-table-column>
									</el-table-column>
									<el-table-column prop="content" :label="$t('label_1046')" align="left">

										<el-table-column prop="time1" :label="$t('btn_42')" align="center">
										</el-table-column>
										<el-table-column prop="time2" :label="$t('label_1058')" align="center">
										</el-table-column>
										<el-table-column prop="time3" :label="$t('btn_43')" align="center">
										</el-table-column>
										<el-table-column prop="time4" :label="$t('label_408')" align="center">
										</el-table-column>
									</el-table-column>
								</el-table>

								<!-- 分页 -->
								<div style="position: absolute;bottom: 15px;left: 30%">
									<Page class="item" ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
									 @parentMethod="searchPage"></Page>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 导出 -->
		<exportMes :exportTitle="exportTitle" :exportData="tableDataTreeTimeExport" :exportList="exportList"
		 ref="exportBox"></exportMes>

	</div>
</template>

<script>
	import "@/assets/css/map/map.css"
	import "@/assets/css/common/spot.css"
	import Page from "@/components/common/page";
	import utils from '@/utils/utils'
	import tree from "@/components/list/tree/tree";
	import file from "@/assets/js/file/file.js";
	import common from "@/assets/js/common/common.js";
	import statistics from "@/assets/js/statistics/statistics.js";
	import exportMes from "@/components/list/export/export";
	export default {
		name: 'maintenanceStatistics',
		components: {
			Page,
			tree,
			exportMes,
		},
		data() {
			return {
				exportList: [{
						column: 'repairman',
						title: '人员',
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
					{
						column: 'repairmanDept',
						title: '人员所属部门',
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
					{
						column: 'numAll',
						title: '工单总数量',
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
					{
						column: 'num',
						title: '工单未完成数量',
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
					{
						column: 'orderTimeout',
						title: '接单超时',
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
					{
						column: 'maintenanceTimeout',
						title: '维修超时',
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
					{
						column: 'time1',
						title: '接单(分)',
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
					{
						column: 'time2',
						title: '路程(分)',
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
					{
						column: 'time3',
						title: '维修(分)',
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},
					{
						column: 'time4',
						title: '故障(分)',
						headerAlign: 'center',
						align: 'center',
						width: '200px'
					},

				],
				tableDataTreeTimeExport: [],
				exportTitle: '维修工作量统计',
				name: '',
				pageNum: 1,
				pageSize: 10,
				pageCount: 0,
				MenuRoleList: [],
				tableChooseInfo: {},
				tableDataList: [],
				Readytime: '',
			}
		},
		watch: {},
		methods: {
			getIndex(index) {
				return (this.pageNum - 1) * this.pageSize + index + 1
			},
			exportClick() {
				this.$refs.exportBox.setExportExcel();
			},
			handleCurrentChangeTree(info) {
				this.tableDataTreeInfo = info;
			},

			handleCurrentChangeTreeTime(info) {
				this.tableChooseInfo = info;
			},



			search() {
				let param = {
					pageNum: 1,
					pageSize: this.pageSize,
				}
				this.searchPage(param);
			},
			searchPage(param) {
				var dataParam = {
					beginTime: this.Readytime[0] + ' 00:00:00',
					endTime: this.Readytime[1] + ' 23:59:59',
					name: this.name,
				};
				var newParam = Object.assign(param, dataParam);
				statistics.maintain(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataList = data.data.records;
						this.pageSize = data.data.size;
						this.pageCount = data.data.total;
						this.pageNum = data.data.current;
						this.$refs['pageModel'].setCurrent(this.pageNum);
					}
				}).catch((response) => {
					console.log(response)
				})
				statistics.maintainExcel(newParam).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableDataTreeTimeExport = data.data;
					}
				}).catch((response) => {
					console.log(response)
				})
			},
			//初始化时间
			initDate() {
				var date = new Date();
				var seperator = "-";
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				var day = date.getDate();
				//开始时间
				var beginTime = year + seperator + this.zero(month) + seperator + '01';
				//结束时间
				var endTime = this.getday(year + seperator + this.zero(month) + seperator + this.zero(day));
				this.Readytime = [beginTime, endTime];
				this.search();
			},
			//补0
			zero(i) {
				return i > 9 ? i : '0' + i;
			},
			//最后一天
			getday(val) {
				var nextMonthFirstDay = new Date(val.substring(0, 4), val.substring(5, 7), 1);
				var oneDay = 1000 * 60 * 60 * 24;
				var lastTime = new Date(nextMonthFirstDay - oneDay);
				var day = lastTime.getDate();
				var month = parseInt(lastTime.getMonth() + 1);
				if (month < 10) {
					month = '0' + month
				}
				if (day < 10) {
					day = '0' + day
				}
				return lastTime.getFullYear() + '-' + month + '-' + day + ' ';
			},

		},
		created() {
			// this.Readytime = [this.getNowTime(), this.getBeforeTime()]
			this.MenuRoleList = this.$store.getters.getMenu;
			this.initDate();
		}
	}
</script>

<style scoped>
	.redFont {
		color: #ff0000;
	}
  .buttonBox .chooseButton {
      margin-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/statisticalAnalysis/maintenanceStatistics.vue